import type { JSX } from "react";
import { Toaster as Sonner } from "sonner";

export function Toaster(): JSX.Element {
  return (
    <Sonner
      position="bottom-right"
      duration={5000}
      visibleToasts={5}
      toastOptions={{
        classNames: {
          toast: "rounded-md border border-[var(--border-default)] shadow-[var(--sh-2)]",
          error: "bg-[var(--intent-danger-bg)] text-[var(--intent-danger-fg)]",
          success: "bg-[var(--intent-success-bg)] text-[var(--intent-success-fg)]",
        },
      }}
    />
  );
}
